import React from "react";
var __jsx = React.createElement;
import { EditorBlock } from 'draft-js';
import { BlockType } from '@uno/common-cms';
import { AtomicBlock } from '../AtomicBlock';
import { HighlightListWrapper } from '../HighlightListWrapper';
import { HighlightWrapper } from '../HighlightWrapper';
import { TableBlock } from '../TableBlock';
import { StyledBlockQuote, StyledH2, StyledH3, StyledUnstyled, WysiwygCommon, WysiwygCommon2 } from './MetaRenderBlock.style';

var wrapComponent = function wrapComponent(props, BlockComponent, Wrapper) {
  var Block = BlockComponent !== null && BlockComponent !== void 0 ? BlockComponent : EditorBlock;

  if (Wrapper === undefined) {
    return __jsx(HighlightWrapper, props, __jsx(WysiwygCommon, null, __jsx(Block, props)));
  }

  return __jsx(HighlightWrapper, props, __jsx(WysiwygCommon, null, __jsx(Wrapper, null, __jsx(Block, props))));
};

var wrapListComponent = function wrapListComponent(props, BlockComponent) {
  var Block = BlockComponent !== null && BlockComponent !== void 0 ? BlockComponent : EditorBlock;
  return __jsx(React.Fragment, null, __jsx(HighlightListWrapper, props, __jsx(WysiwygCommon2, null, __jsx(Block, props))));
}; // eslint-disable-next-line complexity


var MetaRenderBlock = function MetaRenderBlock(props) {
  switch (props.blockProps.type) {
    case BlockType.ATOMIC:
      return wrapComponent(props, AtomicBlock);

    case BlockType.TABLE:
      return wrapComponent(props, TableBlock);

    case BlockType.H2:
      return wrapComponent(props, undefined, StyledH2);

    case BlockType.H3:
      return wrapComponent(props, undefined, StyledH3);

    case BlockType.UNSTYLED:
      return wrapComponent(props, undefined, StyledUnstyled);

    case BlockType.BLOCKQUOTE:
      return wrapComponent(props, undefined, StyledBlockQuote);

    case BlockType.UL:
    case BlockType.OL:
      return wrapListComponent(props, undefined);

    default:
      return wrapComponent(props);
  }
};

export default MetaRenderBlock;